var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {}
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]]
      }
    return t
  }
import { produce } from 'immer'
import Mustache from 'mustache'
import React from 'react'
import { ODGlobalFactory } from './ODGlobalFactory'
import { ODThemeManager } from './ODThemeManager'
var Action
;(function (Action) {
  Action['UpdateDefinition'] = 'ODGlobalProvider/UpdateDefinition'
})(Action || (Action = {}))
var actionUpdateDefinition = function (def, colorPalette) {
  return {
    type: Action.UpdateDefinition,
    def: def,
    colorPalette: colorPalette,
  }
}
var convertStringColor = function (def, path, tmpl) {
  var comps = path.split('.')
  var parent = null
  var value = def
  // tslint:disable-next-line:prefer-for-of
  for (var i = 0; i < comps.length; i += 1) {
    // @ts-ignore
    parent = value
    value = parent[comps[i]]
  }
  parent[comps[comps.length - 1]] = Mustache.render(value, tmpl)
}
var colorKeyPaths = [
  'appHeader.topBorderColor',
  'logo.textColor',
  'sidebar.bgColor',
  'sidebar.iconColor',
  'sidebar.textColor',
  'sidebar.activeBGColor',
  'sidebar.activeIconColor',
  'sidebar.activeTextColor',
  'sidebar.hoverBGColor',
  'sidebar.hoverIconColor',
  'sidebar.hoverTextColor',
]
function createODGlobalReducer() {
  return function (state, action) {
    return produce(state, function (draft) {
      switch (action.type) {
        case Action.UpdateDefinition: {
          draft.def = action.def
          // pre-convert color values.
          colorKeyPaths.forEach(function (p) {
            convertStringColor(draft.def, p, action.colorPalette)
          })
          return
        }
      }
    })
  }
}
function createInitialReducerState(props) {
  return {
    def: props.def,
  }
}
export var ODGlobalContext = React.createContext({})
// basePalette 를 템플릿으로 palette 를 만들고, 둘을 병합한다.
var makePalette = function (def) {
  var paletteWithRendered = {}
  Object.keys(def.palette).forEach(function (key) {
    // @ts-ignore
    var value = def.palette[key]
    paletteWithRendered[key] = Mustache.render(value, def.basePalette)
  })
  return __assign(__assign({}, paletteWithRendered), def.basePalette)
}
export var ODGlobalProvider = function (reactProps) {
  var children = reactProps.children,
    props = __rest(reactProps, ['children'])
  var _a = React.useReducer(createODGlobalReducer(), createInitialReducerState(props)),
    state = _a[0],
    dispatch = _a[1]
  var _b = React.useState(function () {
      return new ODGlobalFactory(state.def)
    }),
    factory = _b[0],
    setFactory = _b[1]
  var _c = React.useState(function () {
      return makePalette(state.def)
    }),
    tmplData = _c[0],
    setTmplData = _c[1]
  var _d = React.useState(function () {
      return new ODThemeManager(state.def)
    }),
    themeManager = _d[0],
    setThemeManager = _d[1]
  React.useEffect(
    function () {
      setFactory(new ODGlobalFactory(state.def))
      setThemeManager(new ODThemeManager(state.def))
      setTmplData(makePalette(state.def))
    },
    [state.def]
  )
  React.useEffect(
    function () {
      dispatch(actionUpdateDefinition(props.def, tmplData))
    },
    [props.def, tmplData]
  )
  var convertThemeString = React.useCallback(
    function (c) {
      if (c === undefined) {
        return undefined
      }
      return Mustache.render(c, tmplData)
    },
    [tmplData]
  )
  var context = {
    state: state,
    factory: factory,
    themeManager: themeManager,
    convertThemeString: convertThemeString,
  }
  return React.createElement(ODGlobalContext.Provider, { value: context }, children)
}
export function useGlobalContext() {
  return React.useContext(ODGlobalContext)
}
//# sourceMappingURL=ODGlobalProvider.js.map
